<template>
    <f7-page
        name="Settings"
        class="onboardingBg"
    >
        <f7-navbar
            large
            no-hairline
            large-transparent
            inner-class="onboardingBg"
            title-large="Subscription"
        >
            <f7-nav-left>
                <f7-link
                    icon="ion-ios-arrow-left"
                    back
                />
            </f7-nav-left>
            <f7-nav-title>Subscription</f7-nav-title>

        </f7-navbar>

        <f7-block style="margin-top: 6px">
            <img
                style="margin: 14px auto; width: 200px;"
                src="../../img/0.4/pulse/Pulse_1.png"
            >
            <p style="font-size: 23px; line-height: 30px">
                You are <span v-if="!user.isSubscribed">NOT </span>subscribed <span v-if="user.subscriptionPeriodType === 'trial'">(TRIAL)</span>
                <!-- <span v-if="!user.isSubscribed && ['app_store', 'play_store'].indexOf(user.subscriptionMethod) > -1"><br><br>You could still be subscribed in the AppStore / PlayStore. </span> -->
            </p>

            <f7-list
                v-if="!user.isSubscribed && user.subscriptionExpiry"
                inset
                class="bordered maxWidth"
                style="margin: 20px auto"
            >
                <f7-list-item
                    :after=" user.subscriptionExpiry ? localizeDate(user.subscriptionExpiry) : '' "
                    title="Expired on"
                />
            </f7-list>
            <f7-list
                v-if="user.isSubscribed && user.subscriptionExpiry"
                inset
                class="bordered maxWidth"
                style="margin: 20px auto"
            >
                <f7-list-item
                    :after=" user.subscriptionExpiry ? localizeDate(user.subscriptionExpiry) : '' "
                    title="Renews on"
                />
            </f7-list>

            <f7-list
                v-if="user.isSubscribed"
                inset
                class="bordered maxWidth"
                style="margin: 20px auto"
            >
                <f7-list-item
                    :after="user.subscriptionMethod === 'promotional' ? `${user.subscriptionMethod} (${user.subscriptionId})` : user.subscriptionMethod ? capitalizeFLetter(user.subscriptionMethod.replace('_',' ')) : 'unknown'"
                    title="Type"
                />
                <f7-list-item
                    :after="user.subscriptionRenewalTerm ? capitalizeFLetter(user.subscriptionRenewalTerm.replace('_',' ')) : '' "
                    title="Term"
                />
                <f7-list-item
                    :after="user.subscriptionRenews ? 'Yes' : 'No' "
                    title="Will renew"
                />
                <f7-list-item
                    :after=" user.subscriptionStarted ? localizeDate(user.subscriptionStarted) : ''"
                    title="Started"
                />
                <f7-list-item
                    :after=" user.subscriptionExpiry ? localizeDate(user.subscriptionExpiry) : '' "
                    title="Expiry"
                />
            </f7-list>

            <f7-list
                inset
                class="bordered maxWidth"
                style="margin: 20px auto"
            >

                <f7-list-item
                    v-if="!user.isSubscribed"
                    link="/subscribeStart"
                >Subscribe or restore</f7-list-item>
                <f7-list-item
                    v-else-if="!user.subscriptionRenews && ['partner', 'promotional'].indexOf(user.subscriptionMethod) === -1"
                    link="/subscribeStart"
                >Renew subscription</f7-list-item>
                <f7-list-item
                    v-else-if="isPgapIOS"
                    link
                    external
                    target="_system"
                    @click="cancelSub()"
                >Cancel subscription (AppStore)</f7-list-item>
                <f7-list-item
                    v-else-if="isPgapANDROID"
                    link
                    external
                    target="_system"
                    @click="cancelSub()"
                >Cancel subscription (PlayStore)</f7-list-item>
                <f7-list-item
                    v-else
                    link
                    style="text-transform: capitalize"
                    @click="cancelSub()"
                >Cancel subscription</f7-list-item>
                <f7-list-item link="/help">Help</f7-list-item>
            </f7-list>

        </f7-block>
    </f7-page>
</template>

<script>
import moment from 'moment';

export default {
    store: ['api', 'user', 'products'],
    data () {
        return {
            loaded: false
        };
    },
    computed: {
        isPgapIOS: function () {
            return pgap && device.platform === 'iOS';
        },
        isPgapANDROID: function () {
            return pgap && device.platform === 'Android';
        },
    },
    created: function () { },
    mounted: function () {
        this.$events.fire('subscriptions-sync');
    },
    methods: {
        localizeDate: function (date) {
            return moment(date).format('LL');
        },
        capitalizeFLetter: function (string) {
            return string[0].toUpperCase() + string.slice(1);
        },
        cancelSub: function () {
            f7.dialog.create({
                title: 'Quick feedback',
                text: 'I wish to cancel because Coral is',
                buttons: [
                    {
                        text: 'Too expensive',
                        onClick: () => {
                            this.reason('too expensive');
                            this.$events.fire('subscriptions-cancel');
                            // this.$events.fire('get-product-from-sku', 'SKU03', (product) => {
                            //     this.$events.fire('trackEvent', `subscription_offer_presented`, '002');
                            //     f7.dialog.create({
                            //         title: 'Limited time offer',
                            //         text: `We launched less than a year ago, we are still working to make your experience better. Stick around and we’ll cut your subscription price to ${product.priceString} for the first year.<br><br>Sound good?`,
                            //         buttons: [
                            //             {
                            //                 text: 'Sure, I’ll keep going',
                            //                 onClick: () => {
                            //                     this.$events.fire('subscriptions-purchase', product);
                            //                 }
                            //             },
                            //             {
                            //                 text: 'No thanks, I’ll cancel',
                            //                 onClick: () => {
                            //                     this.$events.fire('subscriptions-cancel');
                            //                 }
                            //             },
                            //         ],
                            //         verticalButtons: true,
                            //     }).open();
                            // });
                        }
                    },
                    {
                        text: 'Not for me',
                        onClick: () => {
                            this.$events.fire('subscriptions-cancel');
                            this.reason('not for me');
                        }
                    },
                    {
                        text: 'Other',
                        onClick: () => {
                            this.$events.fire('subscriptions-cancel');
                            this.reason('other');
                        }
                    },
                    {
                        text: 'Other (specify)',
                        onClick: () => {
                            f7.dialog.prompt('I am cancelling my subscription to Coral because', (text) => {
                                this.$events.fire('subscriptions-cancel');
                                this.reason(text);
                            });
                        }
                    },
                ],
                verticalButtons: true,
            }).open();
            // f7.dialog.create({
            //     title: 'Not happy with Coral?',
            //     text: 'We’d love to make it up to you. Stick around and we’ll cut your subscription price to $49.99 per year.<br><br>Sound good?',
            //     buttons: [
            //         {
            //             text: 'Sure, I’ll keep going',
            //             onClick: () => {
            //                 this.$events.fire('get-product-from-sku', 'SKU03', (product) => {
            //                     this.$events.fire('subscriptions-purchase', product);
            //                 });
            //             }
            //         },
            //         {
            //             text: 'No thanks, I’ll cancel',
            //             onClick: () => {
            //                 this.$events.fire('subscriptions-cancel');
            //             }
            //         },
            //     ],
            //     verticalButtons: true,
            // }).open();


        },
        reason: function (text) {
            this.$http.post(this.api + '/reasons', {
                type: 'cancellation',
                text,
            });
        }
    }
};
</script>
 